import LandingFooter from '@/components/Landing/Footer';
import LandingHeader from '@/components/Landing/Header';
import VerifyPage from '@/components/Landing/VerifyPage';
import { VerifiedData, getVerifiedData } from '@/src/services/getVerifiedData';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useTranslationByMetaTag } from '../helper';
import style from './_landing/style.module.scss';

const Verify = ({ verifiedData }: { verifiedData: VerifiedData }) => {
  return (
    <div className={style.verifyWrapper}>
      <Head>
        <title>{useTranslationByMetaTag('title')}</title>
        <meta name="description" content={useTranslationByMetaTag('description')} />
        <meta property="og:title" content={useTranslationByMetaTag('og_title')} />
        <meta property="og:description" content={useTranslationByMetaTag('og_description')} />
        <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-touch-icon.png" />
        <link rel="icon" href="/images/favicon.svg" />
        <link rel="icon" type="image/png" sizes="32x32" href="/images/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/images/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#080610" />
        <meta name="msapplication-TileColor" content="#080610" />
        <meta name="theme-color" content="#080610" />
      </Head>
      <LandingHeader />
      <VerifyPage verifiedData={verifiedData} />
      <LandingFooter />
    </div>
  );
};

export const getServerSideProps = async ({ locale, res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=7200');

  let verifiedData: VerifiedData = {};
  try {
    verifiedData = await getVerifiedData();
  } catch (e) {
    console.error('Failed to fetch verified data from Google Sheets:', e);
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      verifiedData,
    },
  };
};

export default Verify;
